import {
  HTTP_REPORTMANAGERBYBRAND_FETCHING,
  HTTP_REPORTMANAGERBYBRAND_SUCCESS,
  HTTP_REPORTMANAGERBYBRAND_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

export const setStateReportByBrandToFetching = () => ({
  type: HTTP_REPORTMANAGERBYBRAND_FETCHING,
});

export const setStateReportByBrandToSuccess = (payload) => ({
  type: HTTP_REPORTMANAGERBYBRAND_SUCCESS,
  payload,
});

export const setStateReportByBrandToFailed = (payload) => ({
  type: HTTP_REPORTMANAGERBYBRAND_FAILED,
});

export const clearreportFianlByBrand = () => {
  return async (dispatch) => {
    dispatch(
      setStateReportByBrandToSuccess({
        data: [],
      })
    );
  };
};

export const reportFinalByBrand = (item) => {
  return async (dispatch) => {
    dispatch(setStateReportByBrandToFetching());

    try {
      const result = await httpClient({
        method: "post",
        url: `${server.REPORTMANAGERBYBRAND_URL}`,
        timeout: 1000 * 30, // Wait for 30 seconds
        data: item,
      });

      // const result = await httpClient.post(
      //   `${server.REPORTMANAGERBYBRAND_URL}`,
      //   item
      // );
      dispatch(setStateReportByBrandToSuccess(result.data));
    } catch (err) {
      dispatch(setStateReportByBrandToFailed());
    }
  };
};
